module.exports = __webpack_public_path__ + "assets/img/zw.2dcf60bb.jpg";